import React, { useState, useEffect } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { languageService } from "./lang/Lang.js";

// English is bundled as the guaranteed fallback; the other languages are
// loaded on demand so the legal texts stay out of the main chunk.
import termsDefaultEn from './legal/terms-default-en.json';
import termsUaeEn from './legal/terms-uae-en.json';

const API_URL = process.env.REACT_APP_API_URL || 'https://ar.sahra.ai/api';

const TERMS_EN = { default: termsDefaultEn, uae: termsUaeEn };

// Languages with translated Terms in ./legal (see the language selector in Links.js)
const TRANSLATED = ['ar', 'de', 'es', 'fr', 'it', 'bg', 'sr'];

export default function Terms() {
  const [termsContent, setTermsContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTerms = async () => {
      try {
        // Get user language ('ar-AE' and the like resolve to 'ar')
        const lang = (languageService.getLanguage() || 'en').toLowerCase().split('-')[0];

        // Check for URL parameter override (for testing)
        const urlParams = new URLSearchParams(window.location.search);
        const countryOverride = urlParams.get('country');

        // Fetch country from geo endpoint
        let country = 'XX';
        if (countryOverride) {
          // Use URL override if provided
          country = countryOverride.toUpperCase();
        } else {
          try {
            const response = await fetch(`${API_URL}/geo`);
            const data = await response.json();
            country = data.country || 'XX';
          } catch (geoError) {
            console.warn('Geo lookup failed, using default terms:', geoError);
          }
        }

        // UAE jurisdiction for the Emirates, Spain jurisdiction everywhere else
        const jurisdiction = country === 'AE' ? 'uae' : 'default';

        let terms = TERMS_EN[jurisdiction];
        if (TRANSLATED.indexOf(lang) !== -1) {
          try {
            const translated = await import(`./legal/terms-${jurisdiction}-${lang}.json`);
            terms = translated.default || translated;
          } catch (importError) {
            console.warn(`Terms translation "${lang}" failed to load, using English:`, importError);
          }
        }

        setTermsContent(terms.terms);
      } catch (error) {
        console.error('Error loading terms:', error);
        // Fallback to default English terms
        setTermsContent(termsDefaultEn.terms);
      } finally {
        setLoading(false);
      }
    };

    loadTerms();
  }, []);

  if (loading) {
    return (
      <div style={{ padding: '60px 20px', textAlign: 'center' }}>
        Loading...
      </div>
    );
  }

  return <div>{ReactHtmlParser(termsContent)}</div>;
}
